module.exports = __webpack_public_path__ + "img/logo.ce93033a.png";